/**
 * https://raw.githubusercontent.com/AlexKhymenko/ngx-permissions/master/projects/ngx-permissions/src/lib/service/permissions.service.ts
 */
import { Inject, Injectable } from '@angular/core';
import { isBoolean, isFunction, transformStringToArray } from '@shared/helpers/utils';
import { NgxPermissionsObject, NgxPermissionsService, NgxPermissionsStore, USE_PERMISSIONS_STORE } from 'ngx-permissions';
import { BehaviorSubject, from, Observable, ObservableInput, of } from 'rxjs';
import { catchError, first, map, mergeAll, switchMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class CustomNgxPermissionsService extends NgxPermissionsService {

    private custom_permissionsSource: BehaviorSubject<NgxPermissionsObject>;

    constructor(
        @Inject(USE_PERMISSIONS_STORE) isolate: boolean = false,
        permissionsStore: NgxPermissionsStore
    ) {
        super(isolate, permissionsStore);

        this.custom_permissionsSource = isolate ? new BehaviorSubject<NgxPermissionsObject>({}) : permissionsStore.permissionsSource;
    }

    public hasPermission(permission: string | string[]): Promise<boolean> {
        if (!permission || (Array.isArray(permission) && permission.length === 0)) {
            return Promise.resolve(true);
        }

        permission = transformStringToArray(permission);
        return this.custom_hasArrayPermission(permission);
    }

    /* public loadPermissions(permissions: string[], validationFunction?: ValidationFn): void {
        return super.loadPermissions(permissions, validationFunction);
    } */

    private custom_hasArrayPermission(permissions: string[]): Promise<boolean> {
        const promises: Observable<boolean>[] = permissions.map(key => {
            // Custom validate function
            /* if (this.custom_hasPermissionValidationFunction(key)) {
                const validationFunction = this.custom_permissionsSource.value[key].validationFunction;
                const immutableValue = {...this.custom_permissionsSource.value};

                return of(null).pipe(
                    map(() => validationFunction(key, immutableValue)),
                    switchMap((promise: Promise<boolean> | boolean): ObservableInput<boolean> => isBoolean(promise) ?
                        of(promise as boolean) : promise as Promise<boolean>),
                    catchError(() => of(false))
                );
            } */

            // check for name of the permission if there is no validation function
            let _key: string = key;
            while (_key.length > 0) {
                if (this.custom_permissionsSource.value[_key]) {
                    return of(true);
                }

                _key = _key.substr(0, _key.lastIndexOf('.'));
            }

            return of(false);
            // return of(!!this.custom_permissionsSource.value[key]);
        });

        return from(promises).pipe(
            mergeAll(),
            first((data) => data !== false, false),
            map((data) => data !== false)
        ).toPromise().then((data: any) => data);
    }

    private custom_hasPermissionValidationFunction(key: string): boolean {
        return !!this.custom_permissionsSource.value[key] &&
            !!this.custom_permissionsSource.value[key].validationFunction &&
            isFunction(this.custom_permissionsSource.value[key].validationFunction);
    }
    
}
